import React from "react";
import { FaWhatsapp } from "react-icons/fa";

const FloatingButton = () => {
  const whatsappNumber = "51959118503"; 

  const handleClick = () => {
    window.open(`https://wa.me/${whatsappNumber}`, "_blank");
  };

  return (
    <button
      onClick={handleClick}
      className="fixed bottom-6 right-6 bg-verde text-white p-4 rounded-full shadow-lg flex items-center justify-center hover:bg-azul-oscuro transition-transform duration-300 hover:scale-110"
    >
      <FaWhatsapp size={30} />
    </button>
  );
};

export default FloatingButton;
